import { useTranslation } from 'react-i18next';
import { Banner, Button, Flex, spaces } from '@electricjs/arc';
import { PermissionEnum } from '@electricjs/core_entity-client';
import { Asset } from '@/types/assets';
import { useGetOrganizationId } from '@/hooks/useGetOrganizationId';
import { useUpdateMdmStatusOverride } from '@/hooks/useUpdateMdmStatusOverride';
import { useUserHasOrganizationPermission } from '@/hooks/useUserHasOrganizationPermission';

export const DeviceNotApplicableBanner = ({ asset }: { asset: Asset }) => {
  const { t } = useTranslation('assets');
  const { space_s } = spaces;
  const organizationId = useGetOrganizationId();
  const { revokeExemption, isLoading } =
    useUpdateMdmStatusOverride(organizationId);
  const canModifyAssets = useUserHasOrganizationPermission(
    PermissionEnum.Assetsupdate
  );

  return (
    <Banner
      intent="warning"
      isFlat
      title={t('assetDetailsContent.deviceNotApplicable.title')}
      id="device-not-applicable-banner"
      isFullWidth
      cta={
        canModifyAssets ? (
          <Flex py={space_s}>
            <Button
              id="remove-mdm-exemption-button"
              variant="outline"
              intent="warning"
              disabled={isLoading}
              onClick={() => revokeExemption(asset)}>
              {t('assetDetailsContent.deviceNotApplicable.removeExemption')}
            </Button>
          </Flex>
        ) : undefined
      }
    />
  );
};
